import react from 'react';
import { oauth2_logout } from '../../APIs';

export default function() {
  async function clearRefresh() {
    try {
        await oauth2_logout()
        window.location.href = "/login" + window.location.search
    } catch(err) {
      alert(err);
    }

  }
  clearRefresh()
  return(
    <div>
      logging you out...
    </div>
  );
}